<template>
  <IconLucideEllipsisVertical />
</template>
